import { makeStyles } from '@material-ui/core';
import { calculateHeight, calculateWidth, rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

interface HomePageLayoutStyleProps {
  leftHanded?: boolean;
}

export const codeContainerStyles = makeStyles(() => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  backgroundWhite: {
    backgroundColor: themeColor.white,
  },
  containerSubHeaderLabel: {
    paddingBottom: calculateHeight(55).stringValue,
    fontWeight: 500,
  },
  buttonOptionsSection: {
    color: themeColor.modalTitle,
    textAlign: ({ leftHanded }: HomePageLayoutStyleProps) => (leftHanded ? 'right' : 'left'),
    float: ({ leftHanded }: HomePageLayoutStyleProps) => (leftHanded ? 'right' : 'left'),
    paddingBottom: 0,
    whiteSpace: 'nowrap',
  },
  returnItemTitleHeaderInside: {
    textAlign: 'center',
    paddingBottom: 0,
  },
  orSection: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  outerMostContainer: {
    width: '0',
  },
  containerAlignment: {
    alignSelf: 'flex-end',
    justifyContent: 'center',
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  outerFlexDesign: {
    flex: '1 1 0',
  },
  flexDesign: {
    flex: 1,
  },
  containerButtonsAlignment: {
    alignSelf: 'flex-end',
    marginTop: rem(2.84375),
  },
  tenderExchangeBodyContainer: {
    justifyContent: 'space-between',
  },
  containerActionButtons: {
    marginBottom: rem(0.875),
  },
  buttonAction: {
    justifyContent: 'start',
    marginBottom: rem(0.625),
    width: '100%',
    maxWidth: rem(12.5),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  },
  containerScrollAction: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: rem(0.938),
    paddingRight: rem(1.875),
    '@media (aspect-ratio: 4/3)': {
      paddingLeft: rem(0.625),
      paddingRight: rem(0.563),
    },
  },
  textScrollCount: {
    fontSize: rem(0.875),
    lineHeight: '1rem',
    letterSpacing: rem(0.031),
    textTransform: 'uppercase',
    color: '#5D6B72',
    '@media (aspect-ratio: 4/3)': {
      fontSize: rem(0.85),
    },
  },
  containerHeaderActions: {
    marginTop: calculateWidth(45.5).stringValue,
    marginBottom: calculateWidth(14).stringValue,
  },
  bottomRow: {
    paddingTop: calculateHeight(13).stringValue,
  },
  leftColumn: {
    maxWidth: calculateWidth(346).stringValue,
  },
  rightColumn: {
    flex: 1,
  },
  verticalListContainer: {
    height: calculateHeight(416).stringValue,
  },
  deviceList: {
    width: '100%',
  },
  pagination: {
    maxWidth: calculateWidth(316).stringValue,
  },
  actionButtons: {
    paddingRight: calculateWidth(20).stringValue,
  },
  bar: {
    marginTop: calculateHeight(15).stringValue,
    marginBottom: calculateHeight(100).stringValue,
  },
  closeButton: {
    padding: `${calculateHeight(16).stringValue} ${calculateWidth(43).stringValue}`,
    fontSize: rem(1),
  },
  buttonBack: {
    marginRight: 5,
  },
  buttonCancel: {
    marginLeft: 5,
  },
}));
